var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5C1.17157 10.5 0.5 11.1716 0.5 12C0.5 12.8284 1.17157 13.5 2 13.5V10.5ZM38.0607 13.0607C38.6464 12.4749 38.6464 11.5251 38.0607 10.9393L28.5147 1.3934C27.9289 0.807611 26.9792 0.807611 26.3934 1.3934C25.8076 1.97919 25.8076 2.92893 26.3934 3.51472L34.8787 12L26.3934 20.4853C25.8076 21.0711 25.8076 22.0208 26.3934 22.6066C26.9792 23.1924 27.9289 23.1924 28.5147 22.6066L38.0607 13.0607ZM2 13.5H37V10.5H2V13.5Z",
    fill: "#F2D861"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29.3174C37.8284 29.3174 38.5 28.6458 38.5 27.8174C38.5 26.989 37.8284 26.3174 37 26.3174L37 29.3174ZM0.939339 26.7567C0.353554 27.3425 0.353554 28.2923 0.939339 28.878L10.4853 38.424C11.0711 39.0098 12.0208 39.0098 12.6066 38.424C13.1924 37.8382 13.1924 36.8884 12.6066 36.3027L4.12132 27.8174L12.6066 19.3321C13.1924 18.7463 13.1924 17.7966 12.6066 17.2108C12.0208 16.625 11.0711 16.625 10.4853 17.2108L0.939339 26.7567ZM37 26.3174L2 26.3174L2 29.3174L37 29.3174L37 26.3174Z",
    fill: "#F2D861"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.f230b7e8ccc1ccab0cee5d8d39fb151c.svg";
export { ForwardRef as ReactComponent };